import React, { useEffect, useState } from "react";

import OmbudsmanForm from "../OmbudsmanForm";
import OmbudsmanSuccess from "../OmbudsmanSuccess";
import NotFoundModal from "../Modals/NotFoundModal";
import GeneralErrorModal from "../Modals/GeneralErrorModal";
import NotPosibleToOpenModal from "../Modals/NotPosibleToOpenModal";

import * as S from "./OmbudsmanHome.style";

const OmbudsmanHome = () => {
  const [showNotFindModal, setShowNotFindModal] = useState(false);
  const [notPossibleModal, setNotPossibleModal] = useState(false);
  const [generalErrorModal, setGeneralErrorModal] = useState(false);

  const [responseOmbudsmanData, setResponseOmbudsmanData] = useState(null);
  const [responseProtocolError, setResponseProtocolError] = useState(null);
  const [responseOmbudsmanError, setResponseOmbudsmanError] = useState(null);

  useEffect(() => {
    const protocolStatus = responseProtocolError?.error?.response?.status;
    const ombudsmanStatus = responseOmbudsmanError?.error?.response?.status;

    if (protocolStatus === 404 || ombudsmanStatus === 404) {
      setShowNotFindModal(true);
    } else if (protocolStatus === 403 || ombudsmanStatus === 403) {
      setNotPossibleModal(true);
    } else if (protocolStatus >= 400 || ombudsmanStatus >= 400) {
      setGeneralErrorModal(true);
    }
  }, [responseProtocolError, responseOmbudsmanError]);

  return (
    <S.Container>
      {!responseOmbudsmanData?.codigoSolicitacao &&
        !responseOmbudsmanData?.data?.protocolo && (
          <>
            <S.Title variant="headline-02" color="primary">
              Abrir uma Ouvidoria
            </S.Title>

            <S.Paragraph variant="headline-08" color="primary-dark">
              Já entrou em contato conosco pelos nossos{" "}
              <a href="/fale-conosco" target="_blank">
                canais de atendimento
              </a>{" "}
              e não resolveu o que precisava? Contate a nossa Ouvidoria. Para
              isso, tenha em mãos o número do protocolo de atendimento anterior.
            </S.Paragraph>

            <OmbudsmanForm
              formError={responseOmbudsmanError}
              setResponseOmbudsmanData={setResponseOmbudsmanData}
              setResponseOmbudsmanError={setResponseOmbudsmanError}
              setResponseProtocolError={setResponseProtocolError}
            />
          </>
        )}
      <NotFoundModal
        show={showNotFindModal}
        onClose={() => setShowNotFindModal(false)}
      />

      <NotPosibleToOpenModal
        show={notPossibleModal}
        onClose={() => setNotPossibleModal(false)}
      />
      <GeneralErrorModal
        show={generalErrorModal}
        onClose={() => setGeneralErrorModal(false)}
      />
      {responseOmbudsmanData?.data?.protocolo ? (
        <OmbudsmanSuccess
          protocol={responseOmbudsmanData?.data?.protocolo}
          strDate={responseOmbudsmanData?.data?.dataPrevista}
        />
      ) : null}
    </S.Container>
  );
};

export default OmbudsmanHome;
